<div class="image_properties">
  <small class="debug">{{me}}</small>
  <mat-label>
    <div>
      <mat-icon style="position: relative; left: -15px; top: 10px; font-size: 20px">image</mat-icon>
      <span style="position: relative; left: -10px">{{'placeholder.resourceType' | transloco}} : {{resource?.resource_type}}</span>
    </div>
  </mat-label>
  <br/>
  <mat-form-field>
    <mat-label>{{'placeholder.resourceName' | transloco}}</mat-label>
    <input inputrestriction="basic1" #resourceNameId matInput (keyup)="updateResourceProperty($event)" placeholder="" value="{{resource?.resource_name}}">
  </mat-form-field>
  @if (isSVG) {
    <div fxFlex="column" fxLayout="row wrap" style="max-width: 280px;">
      <div class="wrap2">
        <div [style.grid-area]="'l1'">
          <button [color]="fillWaitMode ? 'warn' : null" style="width:100px" mat-raised-button (click)="toggleFillWaitMode()">
            <mat-icon style="font-size: 1.7em">format_paint</mat-icon>
            {{'general.fill' | transloco}}
          </button>
        </div>
        <div [style.grid-area]="'l2'">
          <a mat-raised-button (click)="eyeDropperFill()">
            <mat-icon class="addIcons">colorize</mat-icon>
            {{'general.pick' | transloco}}
          </a>
        </div>
        <div [style.grid-area]="'l3'">
          <div [style.grid-area]="'l3'">
            <!--                    (colorPickerClose)="onColorPickerSelectedSvg()"-->
            <input class="colorFontBox"
              [style.background]="selectedFontColorFill"
              [colorPicker]="selectedFontColorFill"
              (colorPickerClose)="toggleFillWaitMode(true)"
              [value]="selectedFontColorFill"
              [readonly]="true"
              (colorPickerChange)="selectedFontColorFill=$event; notifyColorSelected()"/>
            </div>
          </div>
        </div>
        <div class="wrap2">
          <div [style.grid-area]="'l1'">
            <button [color]="strokeWaitMode ? 'warn' : null" style="width: 100px" mat-raised-button (click)="toggleStrokeWaitMode()">
              <mat-icon style="font-size: 1.7em">brush</mat-icon>
              {{'general.stroke' | transloco}}
            </button>
          </div>
          <div [style.grid-area]="'l2'">
            <a mat-raised-button (click)="eyeDropperFillStroke()">
              <mat-icon class="addIcons">colorize</mat-icon>
              {{'general.pick' | transloco}}
            </a>
          </div>
          <div [style.grid-area]="'l3'">
            <input class="colorFontBox"
              [style.background]="selectedFontColorStroke"
              (colorPickerClose)="toggleStrokeWaitMode(true)"
              [colorPicker]="selectedFontColorStroke"
              [value]="selectedFontColorStroke"
              [readonly]="true"
              (colorPickerChange)="selectedFontColorStroke=$event; notifyColorSelected()"/>
            </div>
          </div>
          <div class="wrap3">
            <div [style.grid-area]="'l2'">
              <mat-label>
                {{'general.resetSvgColors' | transloco}}
              </mat-label>
            </div>
            <div [style.grid-area]="'l3'">
              <button mat-icon-button (click)="resetColorSvg()" style="position: relative; left: 30px; top: -12px">
                <mat-icon class="addIcons">delete_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>
      }
      <br/>
      @if (dynamicsInitialized) {
        <div>
          <!--        <div *ngIf="!isSVG" style="position: relative; left: 13px">-->
          @if (experienceLevel > experienceLevelType.BEGINNER) {
              <div fxFlex fxLayoutAlign="center center" fxLayoutGap="32px">
                <button mat-raised-button (click)="openAssociateDialog()">
                  <mat-icon>find_replace</mat-icon>&nbsp;{{'general.swap' | transloco}}
                </button>
                <button mat-raised-button (click)="onEditResource()">
                  <mat-icon>palette</mat-icon>&nbsp;{{'general.paint' | transloco}}
                </button>
              </div>
              <br/>
              <br/>
          }
          <br/>
          <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
          </dynamic-form>
        </div>
      }
      <br/>
      <br/>
    </div>
